import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { Tag } from './ui/Tag';
import { CtaButton } from './ui/CtaButton';
import { checkoutUrl, pricingBonos, pricingTomos, upsellIncludes } from '../data/landing';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-white py-16 sm:py-20" aria-labelledby="pricing-title" data-id="element-75" data-mp="1ege0u7aozlof">
      <div className="mx-auto w-full max-w-6xl px-6" data-id="element-76" data-mp="1jas22qc1cn10">
        <div className="mx-auto max-w-2xl text-center" data-id="element-77" data-mp="1n9r1xwiwttll">
          <Tag data-id="element-78" data-mp="1s9n9u6uqa56f">La Inversión</Tag>
          <h2 id="pricing-title" className="mt-4 font-serif text-2xl font-bold leading-tight text-[#0f172a] sm:text-3xl" data-id="element-79" data-mp="1s8lvntif12kh">
            Elegí tu nivel de implementación
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-80" data-mp="228colqrbv9ig">
            El sistema se paga a sí mismo en la primera semana. Valor real del stack:{' '}
            <span className="font-semibold text-[#0f172a] line-through" data-id="element-81" data-mp="2ws079tmqnb4">
              $264.000
            </span>
          </p>
        </div>

        <div id="comprar" className="mt-10 grid items-stretch gap-6 lg:grid-cols-2" data-id="element-82" data-mp="1mgy652ygnos5">
          <article className="relative flex flex-col overflow-hidden rounded bg-[#0f172a] p-7 sm:p-8" data-id="element-83" data-mp="1hq7y1hynh7tr">
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#16a34a] to-[#d97706]" aria-hidden="true" data-id="element-84" data-mp="1cqbv7m1ovmfs" />
            <span className="inline-flex w-fit rounded bg-[#16a34a] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-85" data-mp="17stnu03blf9w">
              Pack Completo — Acceso Inmediato
            </span>
            <h3 className="mt-4 font-serif text-2xl font-bold text-white" data-id="element-86" data-mp="20hqzvlgxufu7">
              Mega Pack Nutrición
            </h3>
            <p className="mt-1 text-xs text-slate-400" data-id="element-87" data-mp="1vjfr7e2dqbdk">
              6 Tomos + 6 Bonos + Acceso Digital Permanente
            </p>

            <div className="mt-5 flex items-end gap-3" data-id="element-88" data-mp="k1xugyj7uc0j">
              <span className="font-serif text-4xl font-bold text-white" data-id="element-89" data-mp="k3itb0ckch47">
                $19.990
              </span>
              <span className="pb-1 text-sm text-slate-500 line-through" data-id="element-90" data-mp="g2yulsccd5fy">
                $264.000
              </span>
            </div>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#22c55e]" data-id="element-91" data-mp="mh4hnnsiaesd">
              Pago Único · Acceso Permanente
            </p>

            

            <div className="mt-6 flex flex-col items-center" data-id="element-92" data-mp="ciexfod50i8y">
              <CtaButton label="Adquirir Mega Pack Ahora!" href={checkoutUrl} size="md" className="w-full" data-id="element-93" data-mp="cgu4222k75co" />
              <p className="mt-3 text-center text-[10px] uppercase tracking-[0.14em] text-slate-500" data-id="element-94" data-mp="3uul8126xe9la">
                Garantía de 7 días · Devolución sin preguntas
              </p>
            </div>
          </article>

          <article className="relative flex flex-col overflow-hidden rounded border-2 border-[#d97706] bg-[#0f172a] p-7 sm:p-8" data-id="element-95" data-mp="3pxl1kq65z4tn">
            <div className="absolute inset-x-0 top-0 h-1 bg-[#d97706]" aria-hidden="true" data-id="element-96" data-mp="3bxk0papwfxe6" />
            <span className="inline-flex w-fit rounded bg-[#d97706] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-97" data-mp="3fznaluwx6txc">
              Recomendado — Transformación Completa
            </span>
            <h3 className="mt-4 font-serif text-2xl font-bold text-white" data-id="element-98" data-mp="2sd1vegy9as81">
              Sistema de Transformación Total
            </h3>
            <p className="mt-1 text-xs text-slate-400" data-id="element-99" data-mp="369otin1y3ofj">
              12 Semanas · Nutrición + Entrenamiento + Seguimiento
            </p>

            <div className="mt-5 flex items-end gap-3" data-id="element-100" data-mp="3g9floi319rcg">
              <span className="font-serif text-4xl font-bold text-[#fbbf24]" data-id="element-101" data-mp="3g7uritkmsaf4">
                $29.990
              </span>
              <span className="pb-1 text-sm text-slate-500 line-through" data-id="element-102" data-mp="3p29fdkj88t9u">
                $412.000
              </span>
            </div>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-[#fbbf24]" data-id="element-103" data-mp="3l1qp3uwzfv9r">
              Pago Único · Programa Completo
            </p>

            <ul className="mt-5 flex-1 space-y-1.5 border-t border-white/10 pt-5" data-id="element-104" data-mp="3u1m3s9pqy8ej">
              {upsellIncludes.map(item => <li key={item} className="flex items-start gap-2" data-id="element-105" data-mp="hym78piv77j1">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#fbbf24]" strokeWidth={3} aria-hidden="true" data-id="element-106" data-mp="hw9oia5a8t4x" />
                  <span className="text-[13px] leading-snug text-slate-300" data-id="element-107" data-mp="qqo5ch5gobq5">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-6 flex flex-col items-center" data-id="element-108" data-mp="vrligfbm6fks">
              <a href={checkoutUrl} className="inline-flex w-full items-center justify-center gap-3 rounded bg-[#d97706] px-6 py-3 text-sm font-bold uppercase tracking-[0.08em] text-white shadow-[0_10px_30px_-12px_rgba(217,119,6,0.9)] transition-colors duration-200 hover:bg-[#fbbf24] hover:text-[#0f172a] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#fbbf24] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0f172a]" data-id="element-109" data-mp="3v5nvlvyvnwb5">
                Quiero la Transformación Total!
              </a>
              <p className="mt-3 text-center text-[10px] uppercase tracking-[0.14em] text-slate-500" data-id="element-110" data-mp="1ocv5neuqfhwp">
                Garantía de 7 días · Incluye todo el Mega Pack
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>;
}